import { SEVERITIES, WIZARD_TITLE_PREFIXES } from "utils/TicketConstants";
import { UserProfileApi } from "services/userProfile";
import { TICKET_ICONS } from "utils/TicketConstants";
import { Utils } from "../services/utils";

export function formatSupportTicket(
  inputs,
  type,
  auth_status,
  createDescription,
  company_info,
  browser_info,
  event
) {
  const companyId = company_info?.customer?.id;
  let description = "";
  const files = [];
  const titlePrefix =
    type === "Remote Hands"
      ? WIZARD_TITLE_PREFIXES.REMOTEHANDS
      : WIZARD_TITLE_PREFIXES.GUESTACCESS;
  const title = `${titlePrefix} - ${inputs?.title || "No Custom Title"}`;
  const userProfile = new UserProfileApi();
  if (createDescription) {
    description = createDescription(
      inputs,
      auth_status,
      company_info,
      browser_info
    );
  }

  const isWithin24Hours =
    inputs?.startDateTime &&
    !isNaN(new Date(inputs?.startDateTime)) &&
    new Date(inputs?.startDateTime).getTime() - new Date().getTime() <=
      24 * 60 * 60 * 1000;

  const ticket = {
    requester: userProfile.getFirstAndLastName(auth_status),
    requester_id: auth_status.user.id,
    requester_contact_value: auth_status?.user?.userProfile?.emailAddress,
    internalTicketReference: "",
    public_request: null,
    status: "New",
    title,
    description,
    priority: isWithin24Hours ? SEVERITIES.HIGH : SEVERITIES.MEDIUM,
    internal_priority: isWithin24Hours ? SEVERITIES.HIGH : SEVERITIES.MEDIUM,
    type: "Support",
    request_type: type === "Remote Hands" ? "remote-hands" : "guest-access",
    request_method: "portal",
    service: "Colocation",
    process_id: 0,
    record_id: `${event?.eventId}`,
    invite_id: `${event?.eventId}`,
    companyId,
    userId: auth_status.user.id,
    jira_ticket: "",
    location: inputs?.location,
    impact_to_customer: "",
    impact_to_dcblox: "",
    resolution_notes: "",
    general_support_question_type: "",
    general_support_question: "",
    general_support_equipment: "",
    feedback_type: "",
    feedback_jira_ticket: "",
    feedback_browser_data: browser_info,
    billing_detail: [],
    outage_details: [],
    related_tickets: [],
    assignes: [],
    request_log: [],
    comments: [],
    attachments: [],
    notifications: [],
    related_services: [],
    test_results: [],
    files,
  };

  return ticket;
}

export function formatCGTicket(
  inputs,
  type,
  auth_status,
  createDescription,
  company_info,
  browser_info
) {
  const { user } = auth_status;
  const contactDetails = user?.contactDetails;
  let description = "";
  const titlePrefix =
    type === "Remote Hands"
      ? WIZARD_TITLE_PREFIXES.REMOTEHANDS
      : WIZARD_TITLE_PREFIXES.GUESTACCESS;
  const title = `${titlePrefix} - ${inputs?.title || "No Custom Title"}`;

  if (createDescription) {
    description = createDescription(
      inputs,
      auth_status,
      company_info,
      browser_info
    );
  }

  const attendees = inputs?.attendees;
  let formattedAttendees = "";

  attendees &&
    attendees.length !== 0 &&
    attendees.forEach((attendee, index) => {
      formattedAttendees += attendee;

      if (attendees.length !== index + 1) {
        formattedAttendees += "\r\n";
      }
    });
  let nameSplit = inputs?.name;
  nameSplit = nameSplit.split(" ");

  const ticket = {
    Summary: title,
    Urgency: Utils.getPriority(inputs?.priority),
    Priority: Utils.getPriority(inputs?.priority),
    Impact: Utils.getPriority(inputs?.priority),
    Action: "Submit",
    ServiceLocation:
      inputs?.type === "ila"
        ? null
        : Utils.getLocationIDByTag(inputs?.location),
    UDF_ILALoc:
      inputs?.type === "ila" ? Utils.getILALocationID(inputs?.location) : null,
    StringLocation: inputs?.location,
    UDF_ILAAccessAdditionalAttendees: formattedAttendees,
    UDF_ILAAccessReasonForVisit: inputs?.description,
    UDF_ILARequestorCell: contactDetails?.mobile_number
      ? contactDetails?.mobile_number
      : contactDetails?.phone_number,
    UDF_ILAAccessRequestDateTime: inputs?.startDateTime,
    UDF_ILAAccessEndDateTime: inputs?.endDateTime,
    UDF_ILAAccessTotalTimeOnSite: inputs?.duration?.label,
    UDF_ILAAccessRequestor: `${user?.firstname} ${user?.lastname}`,
    UDF_ILAClearanceLevel: inputs?.type === "ila" ? inputs?.clearance : null,
    GuestFirstName: nameSplit?.[0],
    GuestLastName: nameSplit?.[1],
    GuestEmail: inputs?.email,
    GuestPhone: inputs?.phone,
    EmailPIT: contactDetails?.email,
    HistoryRecords: [
      {
        Action: "Description",
        Comment: description,
      },
    ],
  };
  // const ticket = {
  // 	requester: userProfile.getFirstAndLastName(auth_status),
  // 	requester_id: auth_status.user.id,
  // 	public_request: null,
  // 	status: 'NEW',
  // 	title,
  // 	description,
  // 	priority: SEVERITIES.MEDIUM,
  // 	internal_priority: SEVERITIES.MEDIUM,
  // 	type: 'Support',
  // 	request_type: type === 'Remote Hands' ? 'remote-hands' : 'guest-access',
  // 	request_method: 'portal',
  // 	service: 'Colocation',
  // 	process_id: 0,
  // 	record_id: `${event?.eventId}`,
  // 	invite_id: `${event?.eventId}`,
  // 	companyId,
  // 	userId: auth_status.user.id,
  // 	jira_ticket: '',
  // 	location: inputs?.location,
  // 	impact_to_customer: '',
  // 	impact_to_dcblox: '',
  // 	resolution_notes: '',
  // 	general_support_question_type: '',
  // 	general_support_question: '',
  // 	general_support_equipment: '',
  // 	feedback_type: '',
  // 	feedback_jira_ticket: '',
  // 	feedback_browser_data: browser_info,
  // 	billing_detail: [],
  // 	outage_details: [],
  // 	related_tickets: [],
  // 	assignes: [],
  // 	request_log: [],
  // 	comments: [],
  // 	attachments: [],
  // 	notifications: [],
  // 	related_services: [],
  // 	test_results: [],
  // 	files,
  // };

  return ticket;
}

export const sortUsers = (users) => {
  if (!users || users.length === 0) {
    return [];
  }

  const sorted = users.sort((a, b) => {
    if (a.firstName > b.firstName) {
      return 1;
    } else if (a.firstName < b.firstName) {
      return -1;
    }

    return 0;
  });

  return sorted;
};

export const sortModules = (modules) => {
  if (!modules || modules.length === 0) {
    return [];
  }

  const sorted = modules.sort((a, b) => {
    if (a.displayName > b.displayName) {
      return 1;
    } else if (a.displayName < b.displayName) {
      return -1;
    }

    return 0;
  });

  return sorted;
};

export const getTitlePlaceholder = (requestType, tickets) => {
  if (
    !tickets ||
    (requestType !== WIZARD_TITLE_PREFIXES.REMOTEHANDS &&
      requestType !== WIZARD_TITLE_PREFIXES.GUESTACCESS)
  ) {
    return `${requestType}`;
  }

  const titleRegex = new RegExp(`^${requestType} - ${requestType}`);
  const matchingTickets = tickets.filter((ticket) =>
    ticket.name.match(titleRegex)
  );

  return `${requestType} ${matchingTickets.length + 1}`;
};

export const getRemoteHandsTickets = (tickets) =>
  tickets.filter((ticket) => ticket.name.match(/Remote Hands Request/));

export const getGuestAccessTickets = (tickets) =>
  tickets.filter((ticket) => ticket.name.match(/Guest Access Request/));

export function getTicketTypeIcon(details) {
  if (!details?.title) {
    return TICKET_ICONS.SUPPORT;
  }

  const { title: name } = details;

  if (name.includes("Access Request")) {
    return TICKET_ICONS.GUESTACCESS;
  } else if (name.includes("Remote Hands")) {
    return TICKET_ICONS.REMOTEHANDS;
  } else if (name.includes("OUTAGE")) {
    return TICKET_ICONS.OUTAGE;
  } else if (name.includes("Billing") || name.includes("BILLING")) {
    return TICKET_ICONS.BILLING;
  } else if (name.includes("Storage")) {
    return TICKET_ICONS.STORAGE;
  } else {
    return TICKET_ICONS.SUPPORT;
  }
}

export function getTicketPriority(priority) {
  switch (priority) {
    case "1":
      return "High";
    case "2":
      return "High";
    case "3":
      return "Medium";
    case "4":
      return "Low";
    default:
      return "Low";
  }
}

export function createTicketImage(type) {
  if (!type) {
    return "Support";
  }

  if (type.includes("Billing") || type.includes("BILLING")) {
    return {
      name: "BILLING",
      image: TICKET_ICONS.BILLING,
      imageInvert: TICKET_ICONS.BILLING_TICKET_HOVER,
      bgColor: "#b5d334",
      originalbgColor: "#ffffff",
    };
  } else if (type.includes("OUTAGE")) {
    return {
      name: "OUTAGE",
      image: TICKET_ICONS.OUTAGE,
      imageInvert: TICKET_ICONS.OUTAGE_TICKET_HOVER,
      bgColor: "#df6a2e",
      originalbgColor: "#ffffff",
    };
  } else if (type.includes("Storage")) {
    return {
      name: "STORAGE",
      image: TICKET_ICONS.STORAGE,
      imageInvert: TICKET_ICONS.STORAGE_TICKET_HOVER,
      bgColor: "#008388",
      originalbgColor: "#ffffff",
    };
  } else if (type.includes("Remote Hands")) {
    return {
      name: "Remote Hands",
      image: TICKET_ICONS.REMOTEHANDS,
      imageInvert: TICKET_ICONS.REMOTE_HANDS_SELECT,
      bgColor: "#a46cf4",
      originalbgColor: "#ffffff",
    };
  } else if (type.includes("Add Access")) {
    return {
      name: "Remote Hands",
      image: TICKET_ICONS.REMOTEHANDS,
      imageInvert: TICKET_ICONS.REMOTE_HANDS_SELECT,
      bgColor: "#a46cf4",
      originalbgColor: "#ffffff",
    };
  } else if (type.includes("Access Request")) {
    return {
      name: "Guest Access",
      image: TICKET_ICONS.GUESTACCESS,
      bgColor: "#79d2de",
      originalbgColor: "#ffffff",
      imageInvert: TICKET_ICONS.GUEST_ACCESS_SELECT,
    };
  } else {
    return {
      name: "SUPPORT",
      image: TICKET_ICONS.SUPPORT,
      imageInvert: TICKET_ICONS.SUPPPORT_TICKET_HOVER,
      bgColor: "#8060a9",
      originalbgColor: "#ffffff",
    };
  }
}

export function getTicketTitle(name) {
  let displayName = "Support";
  if (!name) {
    return displayName;
  }
  if (name.includes("Access Request")) {
    displayName = "Guest Access";
  } else if (name.includes("Remote Hands")) {
    displayName = "Remote Hands";
  } else if (name.includes("OUTAGE")) {
    displayName = "Outage";
  } else if (name.includes("Billing") || name.includes("BILLING")) {
    displayName = "Billing";
  } else if (name.includes("Storage")) {
    displayName = "Storage";
  }
  return displayName;
}
